import React from 'react'
import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import { navigation } from '../constants/navigation'

const variants = {
    hidden: { opacity: 0, x: 0, y: 20 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 0, x: 0, y: 20 },
}

const ArticleLayout = ({
    children,
    title,
}: {
    children: JSX.Element
    title: string
}) => (
    <>
        <Helmet>
            <title>
                {title === navigation[0].title
                    ? 'Drippy Rugs - Zakázková výroba designových koberečků'
                    : `Drippy Rugs - ${title}`}
            </title>
        </Helmet>

        <motion.article
            className="relative w-full"
            initial="hidden"
            animate="enter"
            exit="exit"
            variants={variants}
            transition={{ duration: 0.2, type: 'easeInOut' }}
        >
            {children}
        </motion.article>
    </>
)

export default ArticleLayout
